<template>
    <div class="max-width-content">

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.users.index')">Werkzoekenden</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ user.fullName }}
            </breadcrumbs>

            <div v-if="!user.deleted_at">
                <link-button :href="route('admin.users.edit', user.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.users.destroy', user.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <div class="mt-8 flex py-5">
            <div class="w-32" v-if="user.avatar">
                <img :src="user.avatar" class="object-cover w-full rounded-full" />
            </div>
            <div class="w-3/4 ml-10">

                <h1 class="text-5xl text-teal-800 mr-1 leading-tight">{{ user.fullName }}</h1>

                <div class="flex">
                    <div class="w-1/2">
                        <div v-if="user.functie" class="mt-3">
                            Functie: <span v-html="user.functie"></span>
                        </div>

                        <div v-if="user.opleidingsniveau" class="mt-3">
                            Opleidingsniveau: <span v-html="user.opleidingsniveau_tag.name"></span>
                        </div>

                        <div v-if="user.werkervaring" class="mt-3">
                            Werkervaring: <span v-html="user.werkervaring_tag.name"></span>
                        </div>

                        <div v-if="user.salaris" class="mt-3">
                            Salaris: <span v-html="user.salaris_tag.name"></span>
                        </div>

                        <div v-if="user.dienstverband" class="mt-3">
                            Dienstverband: <span v-html="user.dienstverband_tag.name"></span>
                        </div>

                        <div v-if="user.industrieTags" class="mt-3">
                            Industrieen:
                            <span v-for="(tag, index) in user.industrieTags" :key="tag.id">
                                {{ tag.name }}<span v-if="index+1 < user.industrieTags.length">, </span>
                            </span>
                        </div>

                        <div v-if="user.beroepsgroepTags" class="mt-3">
                            Beroepsgroepen:
                            <span v-for="(tag, index) in user.beroepsgroepTags" :key="tag.id">
                                {{ tag.name }}<span v-if="index+1 < user.beroepsgroepTags.length">, </span>
                            </span>
                        </div>
                    </div>

                    <div class="w-1/2">
                        <div v-if="user.phone" class="mt-3">
                            Tel: <span v-html="user.phone"></span>
                        </div>

                        <div v-if="user.email" class="mt-3">
                            E-mail: <a :href="'mailto:' + user.email" target="_blank" class="hover:underline">{{ user.email }}</a>
                        </div>

                        <div v-if="user.linkedin" class="mt-3">
                            Linkedin: <a :href="user.linkedin" target="_blank" class="hover:underline">{{ user.linkedin }}</a>
                        </div>

                        <div v-if="user.location_name" class="mt-3">
                            Locatie: <span v-html="user.location_name"></span>
                        </div>
                    </div>
                </div>

                <div class="mt-5 bg-white rounded-lg px-5 py-3" v-if="user.alerts.length > 0">
                    Alert aangemaakt:
                    <ul class="mt-2">
                        <li v-for="alert in user.alerts">
                            <a :href="alert.query" target="_blank" class="hover:underline">{{ alert.query }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";

export default {
    metaInfo() {
        return { title: 'Gebruikers > ' + this.user.fullName };
    },


    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, LinkButton, ConfirmButton },

    props: {
        user: {
            Type: Object
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
